import CommercialStagingForm from "./CommercialStagingForm"

const ImageEnhacementForm = () => {
    return(
        <CommercialStagingForm unitPrice={1.5} form_name="Image Enhancement Service" />
    )
}

export default ImageEnhacementForm;